import {
	Button,
	Grid,
	Group,
	Radio,
	Space,
	Text,
	TextInput,
	Tooltip,
} from '@mantine/core';
import { IconChevronLeft, IconFileSpreadsheet } from '@tabler/icons-react';
import type { Dispatch } from 'react';
import { useExportConfirmationForm } from '../hooks/useExportConfirmationForm';
import { useExportTaxReturn } from '../hooks/useExportTaxReturn';
import type { VatReturnInputs } from '../types/VatReturn';

interface ExcludingVatFormProps {
	fileData: VatReturnInputs;
	setSelectedPage: Dispatch<React.SetStateAction<number>>;
}

export function ExportConfirmation({
	setSelectedPage,
	fileData,
}: ExcludingVatFormProps) {
	const { form, inputs } = useExportConfirmationForm();
	const performExport = useExportTaxReturn(fileData, inputs);

	return (
		<form
			onSubmit={form.onSubmit(() => {
				form.validate();
			})}
		>
			<Grid>
				<Grid.Col span={12}>
					<Radio.Group
						name={'favoriteFramework'}
						label={'Export Type'}
						color="medepos.1"
						key={form.key('selectedExport')}
						{...form.getInputProps('selectedExport')}
					>
						<Group mt={'xs'}>
							<Radio value={'excel'} label={'Excel'} color="medepos.1" />
							<Tooltip label={'Under construction...'}>
								<Radio value={'pdf'} label={'PDF'} color="medepos.1" disabled />
							</Tooltip>
							<Tooltip label={'Under construction...'}>
								<Radio value={'both'} label={'Both'} color="medepos.1" disabled />
							</Tooltip>
						</Group>
					</Radio.Group>
				</Grid.Col>
				<Grid.Col span={12}>
					<TextInput
						label={'PDF File Name'}
						description={'File extension included automatically'}
						placeholder="Insert PDF file name..."
						rightSection={<Text pe={20}>.pdf</Text>}
						key={form.key('pdfName')}
						{...form.getInputProps('pdfName')}
						disabled={
							inputs.selectedExport !== 'both' &&
							inputs.selectedExport !== 'pdf'
						}
					/>
				</Grid.Col>
				<Grid.Col span={12}>
					<TextInput
						label={'Excel File Name'}
						description={'File extension included automatically'}
						placeholder="Insert Excel spreadsheet file name..."
						rightSection={<Text pe={20}>.xlsx</Text>}
						key={form.key('excelName')}
						{...form.getInputProps('excelName')}
						disabled={
							inputs.selectedExport !== 'both' &&
							inputs.selectedExport !== 'excel'
						}
					/>
				</Grid.Col>
				<Grid.Col span={12}>
					<TextInput
						label={'VAT Return Organisation Title'}
						placeholder="Insert organisation title for spreadsheet..."
						key={form.key('title')}
						{...form.getInputProps('title')}
					/>
				</Grid.Col>
			</Grid>
			<Space h={20} />
			<Group justify={'flex-end'}>
				<Button
					color={'medepos.1'}
						variant={'filled'}
					leftSection={<IconChevronLeft />}
					onClick={() => setSelectedPage(2)}
					type={'submit'}
				>
					Go Back
				</Button>
				<Button
					color={'medepos.1'}
						variant={'filled'}
					rightSection={<IconFileSpreadsheet />}
					onClick={async () => {
						if (form.isValid()) {
							await performExport();
						}
					}}
					type={'submit'}
				>
					Export
				</Button>
			</Group>
		</form>
	);
}
